import React from "react";
import { Link } from "react-router-dom";
import { isDemoUrl, isYouTubeUrl } from "../../utils/url-detection";
import { useLocalizedUrl } from "../../hooks/useLocalizedUrl";
import { NavItem } from "./NavItem";

export type MainNavigationItemProps = {
    item: NavItem;
};

export const MainNavigationItem: React.FC<MainNavigationItemProps> = ({ item }) => {
    const localizedHref = useLocalizedUrl(item.href || "/");
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Check if this is a demo URL or YouTube URL
        if (item.href && (isDemoUrl(item.href) || isYouTubeUrl(item.href))) {
            e.preventDefault();
            // Dispatch custom event for demo/video URLs
            const event = new CustomEvent("navigation-demo-click", {
                detail: { url: item.href, type: isDemoUrl(item.href) ? "demo" : "video" },
            });
            window.dispatchEvent(event);
        }
    };

    const linkClassName =
        "text-base font-medium text-nav-item-text px-4 py-2 rounded-full hover:bg-nav-item-background-hover hover:text-nav-item-text-hover transition-colors";

    if (item.href?.startsWith("#")) {
        return (
            <a href={item.href} className={linkClassName}>
                {item.title}
            </a>
        );
    }

    return (
        <Link to={localizedHref} className={linkClassName} onClick={handleClick}>
            {item.title}
        </Link>
    );
};

export default MainNavigationItem;
